import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalComponent } from '@web/birdz-angular';

@Component({
  selector: 'app-modal-confirm-heavy-map-loading',
  templateUrl: './modal-confirm-heavy-map-loading.component.html',
  styleUrls: ['./modal-confirm-heavy-map-loading.component.scss'],
  imports: [TranslocoPipe, ModalComponent, MatDialogModule, MatButtonModule],
})
export class ModalConfirmHeavyMapLoadingComponent {
  private dialogRef = inject<MatDialogRef<ModalConfirmHeavyMapLoadingComponent>>(MatDialogRef);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
